import React from 'react';
import { useParams } from 'react-router-dom';
import SurveyTokenForm from '../components/SurveyTokenForm';
import { POST_EVENT_SURVEY_QUESTIONS } from '../lib/api/surveys';

const PostEventSurveyPage: React.FC = () => {
  const { token = '' } = useParams<{ token: string }>();

  return (
    <SurveyTokenForm
      token={token}
      expectedSurveyKey="post_event"
      surveyTitle="Post-Event Survey"
      questions={POST_EVENT_SURVEY_QUESTIONS}
    />
  );
};

export default PostEventSurveyPage;
